import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import { APP_VERSION } from '@/const';
// utils
import type {
    TDrawerSize,
    TDrawerPosition
} from '@/components/Drawer/Drawer.types.ts';

type TDrawerUI = {
    size: TDrawerSize;
    position: TDrawerPosition;
};

interface IDrawerState {
    ui: Record<string, TDrawerUI | undefined>;
    setUI: (name: string, setting: TDrawerUI) => void;
}

const initialState = {
    ui: {}
};

const useDrawerStore = create<IDrawerState>()(
    persist(
        (set) => ({
            ...initialState,
            setUI: (name: string, setting: TDrawerUI) => {
                set((state) => ({
                    ui: {
                        ...state.ui,
                        [name]: setting
                    }
                }));
            }
        }),
        {
            name: 'drawer-store',
            storage: createJSONStorage(() => globalThis.localStorage),
            partialize: (state) => state,
            version: APP_VERSION
        }
    )
);

export default useDrawerStore;
